<template>
  <div class="orderContiner">
    <div class="containter" v-loading='loading'>
      <div class="topOperation clear">
        <self-back :pageHeaderList="[{ 'name': '订单修改记录' }]" style="float:left;margin:0;margin-right:15px;"></self-back>
        
        <!-- 导出按钮 -->
        <a class="buttonExprt" @click="handleExport">
          <i class="el-icon-download" style="margin-right:5px;"></i>导出修改记录
        </a>

        <el-select style="float:right;width:160px" v-model="customer_name" size='mini' :clearable='true' filterable
          placeholder="请选择客户全称" @change="getOrderEditing(1)">
          <el-option v-for="(item, index) in customerList" :key="index" :label="item.customer_name"
            :value="item.customer_name">
          </el-option>
        </el-select>
        <div class="selectBox clear" style="float:right;margin:6px 20px 0;">
          <div :class="['selectItem', tab == item.id ? 'active' : '']" @click="examineTab(item.id)"
            v-for="(item, index) in examineList" :key="index">
            <div class="icon"></div>{{ item.name }}
          </div>
        </div>
      </div>
      <div class="tableBox">
        <div class="conditionBox">
          <!-- 批量审核 (保持原有逻辑，如果有的话) -->
          <!-- <div class="batchDelete" style="background:#d51414;border-color:#d51414" @click="batchDelete">批量审核</div> -->
          
          <div class="conditionItem">
            <el-select v-model="date_type" size="mini" style="width: 110px; margin-right: 5px;" @change="getOrderEditing(1)">
              <el-option label="财务审核时间" :value="1"></el-option>
              <el-option label="提交修改时间" :value="2"></el-option>
            </el-select>
            <el-date-picker style="width:240px" v-model="search_date" type="daterange" value-format="yyyy-MM-dd"
              size='mini' range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="getOrderEditing(1)">
            </el-date-picker>
          </div>

          <div class="conditionItem">
            <label>任务ID：</label>
            <el-input placeholder="请输入任务ID" v-model.trim="task_id" clearable
              @keydown.enter.native="task_id ? getOrderEditing(1) : ''" @clear="getOrderEditing(1)" size="mini"
              style="width:150px">
            </el-input>
          </div>
          <div class="conditionItem">
            <label>签约公司：</label>
            <el-select v-model="company" style="width:180px" size='mini' clearable @change="getOrderEditing(1)" filterable
              placeholder="请输入签约公司名称">
              <el-option v-for="(item, index) in signCompanyList" :key="index" :label="item.company"
                :value="item.company">
              </el-option>
            </el-select>
          </div>
          <div class="conditionItem">
            <label>mcn机构：</label>
            <el-select style="width:160px" v-model="mcn_name" size='mini' @change="getOrderEditing(1)" :clearable='true'
              filterable placeholder="请选择mcn机构">
              <el-option v-for="(item, index) in mcnList" :key="index" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </div>
          <div class="conditionItem">
            <label>成本公司：</label>
            <el-select style="width:160px" v-model="cost_company_name" size='mini' @change="getOrderEditing(1)"
              :clearable='true' filterable placeholder="请选择成本公司">
              <el-option v-for="(item, index) in costCompanysList" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="conditionItem">
            <template v-if="userInfo.role_id == 10 || userInfo.role_id == 18 || userInfo.role_id == 17 || userInfo.role_id == 21">
              <el-select v-model="pre_audit_status" @change="getOrderEditing(1)" style="width:150px;margin-right:15px;" size="mini"
                clearable placeholder="财务预审状态">
                <el-option v-for="(item, index) in pre_audit_list" :key="index" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </div>
        </div>

        <el-table :data="orderList" ref="multipleTable" border row-key="id" 
          style="width: 100%" class="thwordHidden" height="calc(100vh - 242px)">
          <!-- 去掉选择列，如果是只查看 -->
          <el-table-column :min-width="item.width + 'px'" align="center" label-class-name="thAE"
            :fixed="item.fixed ? true : false" :prop="'order.' + item.prop" :label="item.label" show-overflow-tooltip
            v-for="(item, index) in columns" :key="index"></el-table-column>
          
          <el-table-column min-width="96px" align="center" label="提交修改时间">
             <template slot-scope="scope">
              <div style="line-height: 14px;">{{ scope.row.created_at }}</div>
            </template>
          </el-table-column>
          <!-- 商务/媒介审核时间 -->
          <el-table-column min-width="96px" align="center" label="商务/媒介审核时间">
            <template slot-scope="scope">
              <div style="line-height: 14px;">{{ scope.row.verify_at }}</div>
            </template>
          </el-table-column>
          <el-table-column min-width="96px" align="center" label="财务审核时间">
            <template slot-scope="scope">
              <div style="line-height: 14px;">{{ scope.row.final_verify_at }}</div>
            </template>
          </el-table-column>
          
          <!-- 预审结果 -->
          <el-table-column min-width="96px" align="center" label="预审结果" fixed="right" v-if="userInfo.role_id == 18 || userInfo.role_id == 10 || userInfo.role_id == 17 || userInfo.role_id == 21">
            <template slot-scope="scope">
              <div style="line-height: 14px;" v-if="scope.row.pre_audit_status == 1">{{ '通过' }}</div>
              <div style="line-height: 14px;color:#d51313;" v-if="scope.row.pre_audit_status == 2">{{ `驳回` }}
                <el-popover placement="left-end" title="预审意见" width="400" trigger="hover" :content="scope.row.pre_audit_content">
                  <i class="el-icon-view" slot="reference" style="color: #202652;"></i>
                </el-popover>
              </div>
            </template>
          </el-table-column>

          <el-table-column min-width="80px" align="center" label="状态" fixed="right">
            <template slot-scope="scope">
              <div class="statusBox">
                <!-- 直接复用原有的状态显示逻辑 -->
                <span v-if="scope.row.data_type == 1">
                  <span v-if="!scope.row.mj_status && scope.row.mj_status != 0">商务待审核</span>
                  <span v-else-if="scope.row.mj_status == 2" style="color:#d51313;">商务审核未通过</span>
                  <span v-else-if="scope.row.mj_status == 1 && (!scope.row.cw_status && scope.row.cw_status != 0)"
                    style="color:#EF7400">财务待审核(商务审核通过)</span>
                  <span v-else-if="scope.row.mj_status == 1 && scope.row.cw_status == 2"
                    style="color:#d51313;">财务审核未通过(商务审核通过)</span>
                  <span v-else-if="scope.row.mj_status == 1 && scope.row.cw_status == 1"
                    style="color:#00BB5D;">审核通过</span>
                </span>
                <span v-else>
                  <span v-if="!scope.row.mj_status && scope.row.mj_status != 0">媒介待审核</span>
                  <span v-else-if="scope.row.mj_status == 2" style="color:#d51313;">媒介审核未通过</span>
                  <span v-else-if="scope.row.mj_status == 1 && (!scope.row.cw_status && scope.row.cw_status != 0)"
                    style="color:#EF7400">财务待审核(媒介审核通过)</span>
                  <span v-else-if="scope.row.mj_status == 1 && scope.row.cw_status == 2"
                    style="color:#d51313;">财务审核未通过(媒介审核通过)</span>
                  <span v-else-if="scope.row.mj_status == 1 && scope.row.cw_status == 1"
                    style="color:#00BB5D;">审核通过</span>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="80px" align="center" label="操作" fixed="right">
            <template slot-scope="scope">
               <span style="color:#5B7BFE;cursor: pointer;"
                  @click="() => { order_id = scope.row.order_id; record_id = scope.row.id; journalFlag = true; }">查看</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="listBox">
        <div class="paginationBox">
          <el-pagination small background :current-page="page" :page-size="page_size"
            @current-change="handleCurrentChange" layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    
    <!-- 查看日志 -->
    <el-dialog title="订单记录" :visible.sync="journalFlag" width="60%" top="10vh" :close-on-click-modal='false'>
      <journal v-if="journalFlag" @cancelToast='cancelToast' :order_id='order_id' :record_id='record_id'></journal>
    </el-dialog>
  </div>
</template>
<script>
import columnsJson from '@/components/Order/json/total.js'
import journal from '@/components/Order/orderJournal'

// 假设我们使用相同的API，但添加新的参数支持
// 需要后端支持不传month，而是传date_type + date_range

export default {
  components: {
    journal
  },
  data () {
    return {
      page: 1,
      page_size: 50,
      total: 0,
      loading: false,
      tab: 0,
      orderList: [],
      userInfo: {},
      journalFlag: false,
      order_id: '',
      customerList: [],
      customer_name: '',
      record_id: '',
      columns: columnsJson,
      
      examineList: [
        { name: '全部', id: 0 },
        { name: '待审核', id: 1 },
        { name: '审核通过', id: 2 },
        { name: '审核未通过', id: 3 }
      ],
      
      // 新增状态
      date_type: 1, // 1: 财务审核时间, 2: 提交修改时间
      search_date: [], // 日期范围

      task_id: '',
      signCompanyList: [],
      company: '',
      mcnList: [],
      mcn_name: '',
      cost_company_name: '',
      costCompanysList: [],
      pre_audit_status: '',
      pre_audit_list: [
        { label: '待审核', value: 0 },
        { label: '审核通过', value: 1 },
        { label: '审核驳回', value: 2 },
      ]
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    
    // 初始化默认时间，可选，这里暂时不强制
    // this.date_type = this.userInfo.role_id == 12 ? 2 : 1; 

    this.costCompanys()
    this.mcnListEvent()
    this.customerListEvent();
    this.getSignCompany()
  },
  mounted () {
    this.getOrderEditing(1)
  },
  methods: {
    examineTab (tab) {
      this.tab = tab;
      this.getOrderEditing(1)
    },
    cancelToast () {
      this.journalFlag = false;
    },
    handleCurrentChange (val) {
      this.getOrderEditing(val)
    },
    getOrderEditing (page) {
      this.loading = true;
      this.page = page
      
      let params = {
        page: page,
        pagesize: this.page_size,
        verify_status: this.tab,
        customer_name: this.customer_name,
        task_id: this.task_id,
        company: this.company,
        mcn_name: this.mcn_name,
        cost_company_name: this.cost_company_name,
        pre_audit_status: this.pre_audit_status,
        date_type: this.date_type, // 新增参数
        start_date: this.search_date && this.search_date.length > 0 ? this.search_date[0] : '', // 新增参数
        end_date: this.search_date && this.search_date.length > 0 ? this.search_date[1] : '', // 新增参数
      }
      
      // 复用原有API，但需要后端支持新参数
      this.$axios.get(this.URL.BASEURL + this.URL.getOrderEditing, {
        params: params
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.orderList = res.rst.data;
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false;
      })
    },
    handleExport() {
      if (!this.search_date || this.search_date.length === 0) {
        this.$message({
          message: '请选择时间范围',
          type: 'warning'
        });
        return;
      }

      this.$loading(this.$loadingConfig);
      this.$axios.get(this.URL.BASEURL + this.URL.orderEditingExportNew, {
        params: {
          verify_status: this.tab,
          customer_name: this.customer_name,
          task_id: this.task_id,
          company: this.company,
          date_type: this.date_type,
          start_date: this.search_date[0],
          end_date: this.search_date[1],
          // params required by backend usually included in interceptor, but adding if needed specific ones
          // Based on previous href logic: admin_id, ttl, sign are in interceptor usually?
          // The href version manually added them. Axios interceptor adds them automatically.
        },
        responseType: 'blob'
      }).then((res) => {
        this.$loading(this.$loadingConfig).close();
        if (res.data.type === 'application/json') {
          const reader = new FileReader();
          reader.onload = () => {
             const result = JSON.parse(reader.result);
             this.$message({
                message: result.err || '导出失败',
                type: 'warning'
             })
          };
          reader.readAsText(res.data);
          return;
        }
        
        const content = res.data;
        const blob = new Blob([content]);
        const fileName = `订单修改记录_${this.search_date[0]}至${this.search_date[1]}.xlsx`
        
        if ('download' in document.createElement('a')) {
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          navigator.msSaveBlob(blob, fileName)
        }
      }).catch((err) => {
        console.error(err)
        this.$loading(this.$loadingConfig).close();
        this.$message({
          message: '导出请求异常',
          type: 'error'
        });
      })
    },
    mcnListEvent (page) {
      this.$axios.get(this.URL.BASEURL + this.URL.mcnList, {
        params: {
          page: 1,
          page_size: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.mcnList = res.rst.data;
        }
      }).catch(() => {
      })
    },
    costCompanys () {//成本公司全程列表
      this.$axios.get(this.URL.BASEURL + this.URL.costCompanys, {
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.costCompanysList = res.rst;
        }
      }).catch(() => {
      })
    },
    customerListEvent () {
      this.$axios.get(this.URL.BASEURL + this.URL.customerList, {
        params: {
          page: 1,
          page_size: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.customerList = res.rst.data;
        }
      }).catch(() => {
      })
    },
    getSignCompany () {
      this.$axios.get(this.URL.BASEURL + this.URL.signCompanyList, {
        params: {
          page: 1,
          pagesize: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.signCompanyList = res.rst.data;
        }
      }).catch(() => {
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.containter {
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);

  .topOperation {
    padding: 16px 16px;
    padding-bottom: 6px;
    margin-top: 10px;

    .selectBox {
      display: inline-block;
      vertical-align: middle;

      .selectItem {
        float: left;
        font-size: 13px;
        margin-left: 20px;
        cursor: pointer;

        .icon {
          width: 13px;
          height: 13px;
          border-radius: 3px;
          border: 1px solid #d2d2d2;
          display: inline-block;
          vertical-align: bottom;
          margin-right: 3px;
        }

        &.active {
          .icon {
            border-color: #2662ff;
            position: relative;

            &::before {
              content: "";
              display: inline-block;
              width: 7px;
              height: 7px;
              background: #2662ff;
              border-radius: 1px;
              position: absolute;
              top: 2px;
              left: 2px;
            }
          }
        }
      }
    }
  }
}

.tableBox {
  margin: 0 16px 0;
}

.conditionBox {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  flex-wrap: wrap;

  .conditionItem {
    margin-left: 10px;
    display: flex;
    align-items: center;
    margin-top: 3px;
  }

  label {
    font-size: 13px;
  }
}

.statusBox {
  width: 120%;
  transform: scale(0.9);
  margin-left: -10%;
  height: 100%;
}

.buttonExprt {
  background: #5B7BFE;
  color: #FFFFFF;
  border: 1px solid #5B7BFE;
  float: right;
  font-size: 12px;
  padding: 3px 6px;
  border-radius: 4px;
  margin-left: 10px;
  line-height: 18px;
  cursor: pointer;
}
</style>
<style lang="scss">
.orderContiner {
  .thAE {
    background: #E3E9F3 !important;
  }
  .thMedium {
    background: #F6E6E6 !important;
  }
  .thFinance {
    background: #E6F3F3 !important;
  }
  .thTotal {
    background: #eff0f2 !important;
  }
  .el-table {
    font-size: 12px !important;
  }
  .el-date-editor .el-range-separator {
    width: 10%;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 10px !important;
  }
  .el-table th>.cell {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
  .el-table td,
  .el-table th {
    padding: 5px 0 !important;
  }
  .numberInput .el-input__inner {
    padding: 0 4px !important;
    text-align: center !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/examine/orderModifyRecords.vue